module.exports = __webpack_public_path__ + "static/six-thinking-hats-72cd1b26301e74abfdb3a163aca1a647.jpg";